

const Footer = () => {

  return (
    <footer className="app-footer">
      <p>
        ReactPlay - The MIT License (MIT) Copyright &copy;{new Date().getFullYear()} {' '} is an open-source project made with ❤️ by <a 
          href="https://tapasadhikary.com" 
          target="_blank" 
          rel="noopener noreferrer">Tapas Adhikary</a> and friends.
      </p>
    </footer>
  );
};

export default Footer;
